import styled, { css } from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

type Props = {
  faded: boolean
}

export const TradingControlsSkeleton: React.FC<Props> = ({ faded }) => (
  <Root $faded={faded}>
    <TradingHeadingType>
      <Skeleton
        height={30}
        width="100%"
        css={css`
          border-radius: 50px;
        `}
      />
      <Skeleton
        height={30}
        width="100%"
        css={css`
          border-radius: 50px;
        `}
      />
    </TradingHeadingType>
    <Padded>
      <Heading>
        <Tabs>
          <Skeleton height={20} width={80} />
          <Skeleton height={20} width={40} />
        </Tabs>
        <Wallet>
          <Skeleton
            height={14}
            width={65}
            css={css`
              border-radius: 50px;
            `}
          />
        </Wallet>
      </Heading>
      <Skeleton
        height={30}
        width="100%"
        css={css`
          border-radius: 10px;
        `}
      />
      <QuickButtons>
        <QuickButton height={28} />
        <QuickButton height={28} />
        <QuickButton height={28} />
        <QuickButton height={28} />
      </QuickButtons>

      <GasSettings>
        <GasSettingsGroup>
          <Skeleton height={16} />
          <Skeleton height={16} />
          <Skeleton height={16} />
        </GasSettingsGroup>
        <Skeleton height={16} />
      </GasSettings>

      <OrderButton height={40} width="100%" />
    </Padded>
  </Root>
)

const Root = styled.div<{ $faded: boolean }>`
  border: 1px solid var(--backgroundA-3);
  background: var(--background-2);

  display: grid;
  grid-template-rows: auto 1fr;

  border-radius: 12px;
  padding-block: 10px;

  min-height: 278px;

  ${({ $faded }) =>
    $faded &&
    css`
      opacity: 0.25;
      filter: grayscale(1);
    `}
`

const Padded = styled.div`
  padding-inline: 10px;

  display: grid;
  grid-template-rows: auto 1fr;
  gap: 10px;
`

const TradingHeadingType = styled.div`
  background: var(--background-3);
  gap: 8px;

  display: grid;
  grid-template-columns: auto auto;
  padding: 3px;
  overflow: hidden;

  border-radius: 20px;
  margin-inline: 10px;

  margin-bottom: 10px;
`

const Heading = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const QuickButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 4px;
`

const GasSettings = styled.div`
  display: grid;
  grid-template-columns: 4fr 3fr;
  gap: 15px;

  align-items: center;
`

const GasSettingsGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4px;
`

const Tabs = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px;
`

const Wallet = styled.div`
  display: grid;

  gap: 4px;
  justify-content: end;
  align-items: center;
`

const QuickButton = styled(Skeleton)`
  border-radius: 10px;
`

const OrderButton = styled(Skeleton)`
  border-radius: 10px;
`
